export default __webpack_public_path__ + "static/media/movie-episode-9.0cc228e9.jpg";